export const comments_4987555 = {"data":{"data":[],"links":{}}}